/* Petit Lien v2 - interactions. Aucune écoute de scroll : IntersectionObserver, Web Animations et CSS scroll timelines.
   Tout le contenu reste visible sans JS (la classe ny-js active les états masqués). */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('ny-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* 1. Apparitions au défilement */
  function reveal(ctx) {
    var els = $$('.pl2-rv', ctx);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2. Hero : chaque photo part d'un bord, suit une courbe jusqu'au cadre, puis se révèle à l'écran depuis le centre */
  var STARTS = [
    { x: -9, y: 0, r: -9 },
    { x: 80, y: -5, r: 7 },
    { x: -8, y: 72, r: 6 },
    { x: 81, y: 74, r: -6 }
  ];
  var SVGNS = 'http://www.w3.org/2000/svg';
  function hero(el) {
    if (el.dataset.plReady) return;
    el.dataset.plReady = '1';
    var box = el.querySelector('.pl2-stage__box');
    var screen = el.querySelector('.pl2-screen');
    var shots = $$('.pl2-screen img', el);
    var cards = $$('.pl2-card', el);
    var flash = el.querySelector('.pl2-screen__flash');
    var rings = $$('.pl2-ring', el);
    var trails = el.querySelector('.pl2-trails');
    var pop = el.querySelector('.pl2-pop');
    var tilt = el.querySelector('.pl2-tilt');
    if (!box || !shots.length) return;
    shots[0].classList.add('is-on');
    if (reduce || !cards.length || !box.animate) return;

    var i = 0, timer = null, running = false, visible = true;

    /* inclinaison douce qui suit le pointeur (souris uniquement) */
    if (tilt && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      var step = function () {
        cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
        tilt.style.setProperty('--rx', (cy * -5).toFixed(2) + 'deg');
        tilt.style.setProperty('--ry', (cx * 7).toFixed(2) + 'deg');
        raf = (Math.abs(tx - cx) + Math.abs(ty - cy) > 0.002) ? requestAnimationFrame(step) : null;
      };
      el.addEventListener('pointermove', function (e) {
        var r = box.getBoundingClientRect();
        tx = Math.max(-1, Math.min(1, (e.clientX - r.left) / r.width * 2 - 1));
        ty = Math.max(-1, Math.min(1, (e.clientY - r.top) / r.height * 2 - 1));
        if (!raf) raf = requestAnimationFrame(step);
      });
      el.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(step); });
    }

    function reveal(n) {
      var next = shots[n], prev = shots.filter(function (s) { return s.classList.contains('is-on'); })[0];
      if (!next || next === prev) return;
      next.style.zIndex = 1;
      next.classList.add('is-on');
      var a = next.animate([
        { clipPath: 'circle(0% at 50% 50%)', transform: 'scale(1.12)' },
        { clipPath: 'circle(75% at 50% 50%)', transform: 'scale(1.03)' }
      ], { duration: 950, easing: 'cubic-bezier(.65,0,.35,1)' });
      a.onfinish = function () {
        next.style.zIndex = '';
        if (prev) prev.classList.remove('is-on');
      };
    }
    function pulse() {
      if (flash) { flash.classList.remove('is-go'); void flash.offsetWidth; flash.classList.add('is-go'); }
      rings.forEach(function (r) { r.classList.remove('is-go'); void r.offsetWidth; r.classList.add('is-go'); });
    }
    function notify(name) {
      if (!pop) return;
      pop.querySelector('b').textContent = name;
      pop.querySelector('.pl2-card__av').textContent = name.charAt(0);
      pop.getAnimations().forEach(function (a) { a.cancel(); });
      pop.animate([
        { opacity: 0, transform: 'translateY(10px) scale(.92)' },
        { opacity: 1, transform: 'none', offset: 0.12 },
        { opacity: 1, transform: 'none', offset: 0.82 },
        { opacity: 0, transform: 'translateY(-6px) scale(.98)' }
      ], { duration: 2600, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' });
    }
    function bez(p0, p1, p2, t) { var u = 1 - t; return u * u * p0 + 2 * u * t * p1 + t * t * p2; }

    function send() {
      var k = i % cards.length;
      var card = cards[k];
      var target = k + 1 < shots.length ? k + 1 : 0;
      var st = STARTS[i % STARTS.length];
      card.getAnimations().forEach(function (a) { a.cancel(); });
      card.style.left = st.x + '%';
      card.style.top = st.y + '%';
      var b = box.getBoundingClientRect(), s = screen.getBoundingClientRect(), c = card.getBoundingClientRect();
      var sx = c.left + c.width / 2 - b.left, sy = c.top + c.height / 2 - b.top;
      var ex = s.left + s.width / 2 - b.left, ey = s.top + s.height / 2 - b.top;
      /* point de contrôle : la courbe monte puis plonge vers l'écran */
      var mx = (sx + ex) / 2 + (sx < ex ? -1 : 1) * b.width * 0.04, my = Math.min(sy, ey) - b.height * 0.16;

      /* traînée pointillée qui se dessine */
      if (trails) {
        trails.setAttribute('viewBox', '0 0 ' + b.width + ' ' + b.height);
        var path = document.createElementNS(SVGNS, 'path');
        path.setAttribute('d', 'M' + sx + ' ' + sy + ' Q' + mx + ' ' + my + ' ' + ex + ' ' + ey);
        trails.appendChild(path);
        var len = path.getTotalLength();
        path.style.strokeDasharray = len;
        var tr = path.animate([
          { strokeDashoffset: len, opacity: 0 },
          { strokeDashoffset: len * 0.55, opacity: 1, offset: 0.35 },
          { strokeDashoffset: 0, opacity: .9, offset: 0.78 },
          { strokeDashoffset: 0, opacity: 0 }
        ], { duration: 2900, easing: 'cubic-bezier(.45,.05,.25,1)', fill: 'both' });
        tr.onfinish = function () { path.remove(); };
      }

      var frames = [{ opacity: 0, transform: 'translate(0,14px) rotate(' + st.r + 'deg) rotateY(' + (sx < ex ? -18 : 18) + 'deg) scale(.84)', offset: 0 },
                    { opacity: 1, transform: 'translate(0,0) rotate(' + st.r + 'deg) rotateY(0deg) scale(1)', offset: 0.16 },
                    { opacity: 1, transform: 'translate(0,-3px) rotate(' + st.r + 'deg) scale(1)', offset: 0.36 }];
      for (var q = 1; q <= 4; q++) {
        var t = q / 4;
        var px = bez(sx, mx, ex, t) - sx, py = bez(sy, my, ey, t) - sy;
        frames.push({ opacity: q === 4 ? 0 : 1, transform: 'translate(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px) rotate(' + (st.r * (1 - t)).toFixed(2) + 'deg) scale(' + (1 - t * 0.62).toFixed(3) + ')', offset: 0.36 + 0.64 * t });
      }
      var anim = card.animate(frames, { duration: 2900, easing: 'cubic-bezier(.5,0,.3,1)', fill: 'both' });
      anim.onfinish = function () {
        reveal(target);
        pulse();
        notify(card.dataset.name || '');
      };
      i++;
    }
    function loop() {
      if (!running) return;
      send();
      timer = setTimeout(loop, 4600);
    }
    function start() { if (running || !visible || document.hidden) return; running = true; timer = setTimeout(loop, 1100); }
    function stop() { running = false; clearTimeout(timer); }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; visible ? start() : stop(); }, { threshold: 0.25 }).observe(box);
    } else { start(); }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  }

  /* 3. Comment ça marche : l'étape au centre de l'écran pilote l'image */
  function how(el) {
    if (el.dataset.plReady) return;
    el.dataset.plReady = '1';
    var steps = $$('.pl2-how__step', el);
    var imgs = $$('.pl2-how__media img', el);
    if (!steps.length) return;
    function set(n) {
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === n); });
      imgs.forEach(function (m, k) { m.classList.toggle('is-on', k === n); });
    }
    set(0);
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) set(steps.indexOf(en.target)); });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    steps.forEach(function (s) { io.observe(s); });
  }

  /* 4. Galeries : vignettes, flèches du clavier, balayage sur mobile */
  function gallery(el) {
    if (el.dataset.plReady) return;
    el.dataset.plReady = '1';
    var main = $$('.pl2-gal__main img', el);
    var btns = $$('.pl2-gal__thumbs button', el);
    var idx = el.querySelector('[data-pl2-idx]');
    var cur = 0;
    function go(k) {
      if (!main.length) return;
      k = (k + main.length) % main.length;
      cur = k;
      main.forEach(function (m, j) { m.classList.toggle('is-on', j === k); });
      btns.forEach(function (o, j) { o.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
      if (idx) idx.textContent = k + 1;
      if (btns[k] && btns[k].scrollIntoView && btns[k].parentNode.scrollWidth > btns[k].parentNode.clientWidth) btns[k].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
    btns.forEach(function (b, k) {
      b.addEventListener('click', function () { go(k); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); btns[cur].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); btns[cur].focus(); }
      });
    });
    var box = el.querySelector('.pl2-gal__main'), x0 = null;
    if (box) {
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      });
    }
  }

  /* 5. Fiche produit : quantité et barre d'achat mobile */
  function pdp(el) {
    if (el.dataset.plReady) return;
    el.dataset.plReady = '1';
    var form = el.querySelector('form.pl2-pdp__form');
    var qty = el.querySelector('[data-pl2-qty] input');
    $$('[data-pl2-qty] button', el).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.min(10, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.step, 10)));
        qty.value = v;
      });
    });
    var bar = el.querySelector('[data-pl2-pdp-bar]');
    var atc = el.querySelector('[data-pl2-atc]');
    var barBtn = el.querySelector('[data-pl2-bar-atc]');
    if (barBtn && form) barBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    if (form) form.addEventListener('submit', function () { if (atc) { atc.setAttribute('aria-busy', 'true'); atc.style.opacity = '.75'; } });
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    new IntersectionObserver(function (es) {
      var gone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-on', gone);
    }, { threshold: 0 }).observe(atc);
  }

  function boot(ctx) {
    reveal(ctx);
    $$('[data-pl2-hero]', ctx).forEach(hero);
    $$('[data-pl2-how]', ctx).forEach(how);
    $$('[data-pl2-gallery]', ctx).forEach(gallery);
    $$('[data-pl2-pdp]', ctx).forEach(pdp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
